import {Row, RowType, TableData} from "../../components/Table/obj/TableData";

export const bizExternalCustomerTable = new TableData([
    new Row([ "Name", "Type", "Collation", "Attributes", "Null", "Default" ], RowType.HEADER),
    new Row([ "preferred_name", "varchar(16)", "utf8", "", "Yes", "NULL" ])
])
